import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { CardChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class CardChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): CardChartData {

    const totalOverdueCardsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.card.total.day || {},
        aggregationLevel,
      );

    const cardCreatedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.card.created) || {},
        aggregationLevel,
      );

    const cardClosedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.card.closed) || {},
        aggregationLevel,
      );

    const cardDurationData =
      this.statisticsAggregator.aggregateDuration(
        this.statisticsTransformer.collectInnerValues2D(stats.card.duration) || {},
        aggregationLevel,
      );

    return {
      totalCards: totalOverdueCardsData,
      created: cardCreatedData,
      closed: cardClosedData,
      duration: cardDurationData,
    };
  }

}
